import type { AppStore } from "@src/stores/AppStore";
import { action, computed, makeObservable, observable } from "mobx";

export type TTasksViewMode = "list" | "board";

const TASKS_VIEW_MODE_STORAGE_KEY = "tasks-view-mode";

export class TasksViewModeStore {
  @observable.ref viewMode: TTasksViewMode = "list";

  constructor(private readonly appStore: AppStore) {
    makeObservable(this);
    this.viewMode = this.getViewMode();
  }

  /**
   * Keeps scoped users (client and partner access) on the list — a board
   * picked earlier in this browser must not show for them. Computed, as the
   * user loads after the store is created.
   */
  @computed
  get canUseBoard(): boolean {
    return this.appStore.authStore.isInternalUser;
  }

  @computed
  get isBoard(): boolean {
    return this.canUseBoard && this.viewMode === "board";
  }

  @computed
  get isList(): boolean {
    return !this.isBoard;
  }

  @computed
  get getPaginationKey(): string {
    if (this.isBoard) {
      return "tasksKanban";
    }

    return "tasksListing";
  }

  @action.bound
  setViewMode(viewMode: TTasksViewMode): void {
    this.viewMode = viewMode;
    this.saveViewMode(viewMode);
  }

  getViewMode(): TTasksViewMode {
    try {
      return localStorage.getItem(TASKS_VIEW_MODE_STORAGE_KEY) === "board"
        ? "board"
        : "list";
    } catch (_error) {
      return "list";
    }
  }

  private saveViewMode(viewMode: TTasksViewMode): void {
    try {
      localStorage.setItem(TASKS_VIEW_MODE_STORAGE_KEY, viewMode);
    } catch (_error) {}
  }
}
